import React from "react";
import InternalRouter from "../InternalRouter";
import Login from '../Authentication/Login/Login';

export default function AuthorizedOnlyRedirector({isAuthenticated, setIsAuthenticated}: {isAuthenticated: boolean, setIsAuthenticated:  React.Dispatch<React.SetStateAction<boolean>>}) {
  return isAuthenticated ? <InternalRouter setIsAuthenticated={setIsAuthenticated} /> : <Login setIsAuthenticated={setIsAuthenticated} />;
}